import React from 'react'
import './SavedCollection.css';


const SavedCollection = () => {
    const savedCollection_img = "https://b.zmtcdn.com/webFrontend/3f23e42e880731a30472723e77825f431575972761.png"
    return (
        <>
            <div className="saved-items d-flex flex-column align-items-center justify-content-center">
                <div className="img-saved">
                    <img className='saved-img' src={savedCollection_img} alt="" />
                </div>
                <div className="text-saved text-center">
                    <h4>Save collection you love!</h4>
                    <h5>
                        They'll appear here.</h5>
                </div>
            </div>
        </>
    )
}

export default SavedCollection